import React from 'react'
import { motion } from 'framer-motion'
import SmallRectangle from '../../../assets/RectangleOne.svg';
import BigRectangle from '../../../assets/RectangleTwo.svg';
import Icon3 from '../../../assets/RectCardIcon1.svg';
import Icon2 from '../../../assets/RectCardIcon2.svg';
import Icon1 from '../../../assets/RectCardIcon3.svg';
import Threads from '../Threads/Threads';
import './howCard.css'

const cardVariants = {
    offscreen: { opacity: 0, y: 60 },
    onscreen: { opacity: 1, y: 0, transition: { type: 'spring', bounce: 0.2, duration: 0.8 } }
};

const HowCard = () => {
    return (
        <div style={{ width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center', padding: '70px', overflow: 'hidden' }}>
            {/* Animated Threads background */}
            <div style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 0 }}>
                <Threads color={[0, 1, 0.56]} amplitude={5} distance={0.2} enableMouseInteraction={true} />
            </div>
            {/* Content above background */}
            <div className="howcard-main-content" style={{ position: 'relative', zIndex: 1, width: '800px', display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
                <div className="howcard-row" style={{ display: 'flex', flexDirection: 'row', gap: '24px', width: '90%', justifyContent: 'center' }}>
                    {/* Card 1 */}
                    <motion.div
                        className="howcard-card"
                        variants={cardVariants}
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.3 }}
                        style={{
                            flex: 1, minWidth: 0, background: `url(${SmallRectangle}) no-repeat center/cover`,
                            borderRadius: '24px', padding: '40px', color: '#fff', minHeight: '220px',
                            display: 'flex', flexDirection: 'column', justifyContent: 'center', cursor: 'pointer',
                            position: 'relative', overflow: 'hidden'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '20px' }}>
                            <img style={{ width: '100px', height: 'auto' }} src={Icon1} alt='icon-1' />
                            <div>
                                <h2 style={{
                                    color: '#00FD8E',
                                    fontFamily: 'Plus Jakarta Sans',
                                    fontSize: '22px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: '22px',
                                    letterSpacing: ' -1px',
                                    paddingBottom: '10px',
                                }}>Innovate<br />Anywhere</h2>
                                <p style={{
                                    color: '#BFBFBF',
                                    fontFamily: 'Plus Jakarta Sans',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: '18px',
                                    letterSpacing: '-0.489px'
                                }}>Browse through a library of powerful tools and software, categorized for every need—AI/ML, Data Science, Reporting, and more.</p>
                            </div>
                        </div>
                    </motion.div>
                    {/* Card 2 */}
                    <motion.div
                        className="howcard-card"
                        variants={cardVariants}
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.3 }}
                        style={{
                            flex: 1, minWidth: 0, background: `url(${SmallRectangle}) no-repeat center/cover`,
                            borderRadius: '24px', padding: '40px', color: '#fff', minHeight: '220px',
                            display: 'flex', flexDirection: 'column', justifyContent: 'center', cursor: 'pointer',
                            position: 'relative', overflow: 'hidden'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '20px' }}>
                            <img style={{ width: '100px', height: 'auto' }} src={Icon2} alt='icon-2' />
                            <div>
                                <h2 style={{
                                    color: '#00FD8E',
                                    fontFamily: 'Plus Jakarta Sans',
                                    fontSize: '22px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: '22px',
                                    letterSpacing: ' -1px',
                                    paddingBottom: '10px',
                                }}>Pick<br />Your Tool</h2>
                                <p style={{
                                    color: '#BFBFBF',
                                    fontFamily: 'Plus Jakarta Sans',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: '18px',
                                    letterSpacing: '-0.489px'
                                }}>Browse through a library of powerful tools and software, categorized for every need—AI/ML, Data Science, Reporting, and more.</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
                {/* Big Card */}
                <motion.div
                    className="howcard-big-card"
                    variants={cardVariants}
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: true, amount: 0.3 }}
                    style={{
                        width: '90%', background: `url(${BigRectangle}) no-repeat center/cover`,
                        borderRadius: '24px', padding: '40px', color: '#fff', minHeight: '220px',
                        display: 'flex', flexDirection: 'column', justifyContent: 'center', cursor: 'pointer',
                        position: 'relative', overflow: 'hidden'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '20px' }}>
                        <img style={{ width: '100px', height: 'auto' }} src={Icon3} alt='icon-3' />
                        <div>
                            <h2 style={{
                                color: '#00FD8E',
                                fontFamily: 'Plus Jakarta Sans',
                                fontSize: '22px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: '22px',
                                letterSpacing: ' -1px',
                                paddingBottom: '10px',
                            }}>Launch<br />Instantly</h2>
                            <p style={{
                                color: '#BFBFBF',
                                fontFamily: 'Plus Jakarta Sans',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: '18px',
                                letterSpacing: '-0.489px'
                            }}>Browse through a library of powerful tools and software, categorized for every need—AI/ML, Data Science, Reporting, and more.</p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default HowCard